import React, { Component } from 'react';

class Sanitize {
	
	static capitalizeFirstLetter(str) {
	  return str.charAt(0).toUpperCase() + str.slice(1);
	}
	
	static integerKeyPress(e){
		if (e.which != 8 && (e.which < 48 || e.which > 57) ) {
			//showAdvice(this, "Integer values only");
			e.preventDefault();
			return false;
		}
	}
	
	static decimalKeyPress(e){
		if ( e.which != 8 && e.which != 46 && (e.which < 48 || e.which > 57)) {
			//showAdvice(this, "Decimal numbers only");
			e.preventDefault();
			return false;
		}
		if (e.which == 46 && e.target.value.indexOf(".") != -1) {
		   // showAdvice(this, "Only one period allowed in decimal numbers");
		   e.preventDefault();
			return false;   // only one decimal allowed
		}
	}
	
	static lettersOnly(e){
		var inputValue = e.which;
        // allow letters and whitespaces only.
        if(e.which != 8 && !(inputValue >= 65 && inputValue <= 122) && (inputValue != 32 && inputValue != 0)) { 
            e.preventDefault(); 
			return(false);
        }
	}

	static splitStr(str){
		try{
			var ar = str.split(".");
			if(ar.length >1){
				if(parseFloat(ar[1]) > 0){
					return parseFloat(str).toFixed(1);
				}
				else{
					return parseFloat(ar[0]);
				}
			}
		}
		catch(error){
			console.log(error);
			return str;
		}
	}
	
	static dmyDash(d){		
		if(d==null || d=='' || d=='0000-00-00') return  '';		
		var today = new Date(d);

		var dd = today.getDate();
		var mm = today.getMonth()+1; //January is 0!
		var yyyy = today.getFullYear();

		if(dd<10) {
			dd = '0'+dd
		} 

		if(mm<10) {
			mm = '0'+mm
		} 

		today = dd + '-' + mm + '-' + yyyy;
		return today;
	}
	
	/** Group by data using multiple column **/
	static groupByMultiple( array , f )
	{
		  var groups = {};
		  array.forEach( function( o )
		  {
			var group = JSON.stringify( f(o) );
			groups[group] = groups[group] || [];
			groups[group].push( o );  
		  });
		  return Object.keys(groups).map( function( group )
		  {
			return groups[group]; 
		  });
	}
	
	static replacepurpose(str){
		
		var rv = 'Default' ;
		
		if(str == 'groupsms_single')
		{
			rv = 'Custom'
		}
		else if(str == 'homework')
		{
			rv = 'Home Work'
		}
		else if(str == 'groupsms_studentall')
		{
			rv = 'All Students'
		}
		else if(str == 'groupsms_employeeall')
		{
			rv = 'All Employees'
		}
		else if(str == 'groupsms_allstudents')
		{
			rv = 'All Students'
		}
		else if(str == 'groupsms_allemployees')
		{
			rv = 'All Employees'
		}
		else if(str == 'groupsms_student')
		{
			rv = 'Students'
		}
		else if(str == 'groupsms_section')
		{
			rv = 'Section Wise'
		}
		else if(str == 'groupsms_section_app')
		{
			rv = 'Section Wise'
		}
		else if(str == 'groupsms_class')
		{
			rv = 'Class Wise'
		}
		else if(str == 'groupsms_class_app')
		{
			rv = 'Class Wise'
		}
		else if(str == 'groupsms_class_multiple')
		{
			rv = 'Class Wise'
		}
		else if(str == 'groupsms_employeedestination')
		{
			rv = 'Destination Wise'
		}
		else if(str == 'admission')
		{
			rv = 'Admission'
		}
		else if(str == 'attendance')
		{
			rv = 'Attendance'
		}
		else if(str == 'birthdaywish_student')
		{
			rv = 'Student Birthday Greetings'
		}
		else if(str == 'birthdaywish_employee')
		{
			rv = 'Staff Birthday Greetings'
		}
		else if(str == 'Homework_By_Staff')
		{
			rv = 'Homework By Staff'
		}
		else if(str == 'groupsms_groupstudents'){

			rv = 'Group By Student'
		}
		else if(str == 'groupsms_groupemployees'){

			rv = 'Group By Staff'
		}
		
		return rv;
	}
	
	static getClass(classid){
		var rv = '';
		
		switch(classid){
			case '1': rv = 'Pre-KG';
			break;
			case '2': rv = 'LKG';
			break;
			case '3': rv = 'UKG';
			break;
			case '4': rv = 'STD I';
			break;
			case '5': rv = 'STD II';
			break;
			case '6': rv = 'STD III';
			break;
			case '7': rv = 'STD IV';
			break;
			case '8': rv = 'STD V';
			break;
			case '9': rv = 'STD VI';
			break;
			case '10': rv = 'STD VII';
			break;
			case '11': rv = 'STD VIII';
			break;
			case '12': rv = 'STD IX';
			break;
			case '13': rv = 'STD X';
			break;
			case '14': rv = 'STD XI';
			break;
			case '15': rv = 'STD XII';
		}
		return rv;
	}
	
	static getSection(sectionid){
		var rv = '';
		
		switch(sectionid){
			case '1': rv = 'A';
			break;
			case '2': rv = 'B';
			break;
			case '3': rv = 'C';
			break;
			case '4': rv = 'D';
			break;
			case '5': rv = 'E';
			break;
			case '6': rv = 'F';
			break;
			case '7': rv = 'G';
			break;
			case '8': rv = 'H';
			break;
			case '9': rv = 'I';
		}
		return rv;
	}
	
	static getMonthName(month){
		var rv = '';
		const monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
        rv = monthNames[parseInt(month)-1];
		return rv;
	}
	
}

export default Sanitize;


// WEBPACK FOOTER //
// ./src/Sanitize.js